import { createContext, useContext } from 'react';

import { type FieldAttributes } from '../services/field-attributes';

export const FieldAttributesContext = createContext<
  FieldAttributes | undefined
>(undefined);

export function useFieldAttributes() {
  const context = useContext(FieldAttributesContext);
  if (typeof context === 'undefined') {
    throw new Error(
      'useFieldAttributes must be used inside a <FieldAttributesContext.Provider>',
    );
  }

  return context;
}
